import { useSelector, useDispatch } from 'react-redux';
import { idUserAction, initState, LoadData, getAllDocs } from '../redux/actions/sharedViews';
import { actionTypes } from "../redux/contants/actionTypes";
import { useCallback } from 'react';


export const useSharedViews = () => {
    const dispatch = useDispatch();
    const {
        listAllDocs,
        isLoading,
        listDeatils,
        listConfiguration,
        columsTableDeatails,
        isLoadingDetails,
        rowsChecked,
        filters,
        pagination,
        counter,
        id_user_action,
        id_company,
        select_company,
        table_check,
        rowsCheckedDetails,
        infoSudMenu
    } = useSelector(state => state.sharedViews);

    const handleRowsChecked = (obj) => {
        dispatch(LoadData(actionTypes.rowsChecked, obj));
    };

    const updateFilters = (newFilters) => {
        dispatch(LoadData(actionTypes.filterAndPagination, { filters: { ...filters, ...newFilters }, pagination }));
    };

    const updatePagination = (newPagination) => {
        dispatch(LoadData(actionTypes.filterAndPagination, { filters, pagination: { ...pagination, ...newPagination } }));
    };

    const resetInitState = useCallback(() => {
        dispatch(initState());
    }, [dispatch]);

    const setIdUserAction = useCallback((idUserA) => {
        dispatch(idUserAction(idUserA));
    }, [dispatch]);

    return [{
        updateFilters,
        updatePagination,
        handleRowsChecked,
        getAllDocs,
        resetInitState,
        setIdUserAction,
        listAllDocs,
        isLoading,
        listDeatils,
        listConfiguration,
        columsTableDeatails,
        infoSudMenu,
        isLoadingDetails,
        rowsChecked,
        filters,
        pagination,
        counter,
        id_user_action,
        id_company,
        select_company,
        table_check,
        rowsCheckedDetails
    }];
};